module.exports = __webpack_public_path__ + "img/delete-budget.756ba5de.svg";